module.exports = __webpack_public_path__ + "img/人脸.60700108.jpg";